'use strict';

var _          = require('underscore');
var $ = require('jquery');
var jQuery = $;
var Icons = require('../../../ui-icons/releases/bundle/rounded-bold-icons-bundle.js');

var _defaults = {
    s3_bucket_name: 'https://s3-us-west-1.amazonaws.com/123d-circuits-assets/'
}

/**
 * Core
 * is inherited by the mayority of the UI classes and should always be used through inheritance
 * @param {object} [options] an options object
 * @param {(string|Element)} [options.target] a string or jquery selector where the element should be deployed
 * @param {object} [options.fields] an object with optional template fields that can be used in the template string
 */

class Core {

    /**
     * Our constructor mixes the options with the defaults (_defaults function) provided by the implementation class
     * @abstract
     * @param {Object} [options] - Options object with the overrides for our defaults
     */

    constructor(options) {
        if(options instanceof jQuery){
            this._options = options = {target: options, fields: {}};
        }else{
            options = (options || {target: undefined, fields: {}});
            if(_.isUndefined(options.target)) options.target = (this._defaults().target || '');
            if(_.isUndefined(options.fields)) options.fields = {};
            if(_.isUndefined(options.prepend)) options.prepend = false;
            _.defaults(options.fields, this._defaults().fields);
            this._options = options;
        }

    }

    /**
     * Does the actual rendering for the template and references the result in the $el var of the class
     * @param {boolean} [override=false] should the template override the target or not?
     * @returns {Object} $el - jQuery object with the rendered result
     */

    render(override){
        if(_.isUndefined(override)){
            override = false;
        }
        var template_helper = {

            'embedded_svg': function(name, type) {
                if(!name){
                    return '';
                }else{
                    if(type) console.warn('Icon with different type not supported through embedded_svg query anymore');
                    var propertyName = name.replace( '.svg', '' );
                    return Icons[propertyName];
                }
            },

            'params': function(name) {
                var params = window.location.href.split( /[\?&]+/ );
                for (var i = 0; i < params.length; i++) {
                    var pair = params[i].split( '=' );
                    if ( pair[0] == name ) {
                        return pair[1];
                    }
                }
                return null;
            },

            'link_to_s3_file': function(fileName) {
                if (fileName == ""){
                    return "";
                }

                if (fileName.indexOf('http://') != -1 || fileName.indexOf('https://') != -1) {
                    return fileName;
                }

                return _defaults.s3_bucket_name + fileName;
            },

            'image_tag': function(args) {
                var src = args[0];
                var options = args[1];
                var image = '<img src="' + src + '" ';
                Object.keys(options).forEach(function(name){
                    image += ' ' + name + '="' + options[name] + '"';
                });
                image += '>';
                return image;
            },

            'external_url': function(url) { //ONLY TO BE USED WITH TRUSTED URLS
                if(url === "") {
                    return "";
                }
                if (typeof url != "string") {
                    // console.warn("invalid url: " + url);
                    return "";
                }
                if (url.indexOf('http://') == 0 || url.indexOf('https://') == 0 || url.indexOf('/') == 0 || url[0] == '#') {
                    if(url.indexOf("'") == -1 && url.indexOf('"') == -1) {
                        return url;
                    }
                }
                console.warn("untrusted url: " + url);
                return "";  //unsafe
            },
        };

        if(!_.isUndefined(this.template)){
            var view = _.template(this.template); // Contstruct our template string
            _.extend(this._options.fields, template_helper); // We extend our fields with some helpers so we can include icons and s3 links for example

            // Call our template and add it to the $el of our class
            if(override){
                this.$el = $(this._options.target).html(view(this._options.fields));
            }else{
                if(this._options.prepend){
                    this.$el = $(view(this._options.fields)).prependTo($(this._options.target));
                }else{
                    this.$el = $(view(this._options.fields)).appendTo($(this._options.target));    
                }
                
            }
            console.assert($(this.$el).length);
        }

    }

    show() {
        this.$el.show(); return this;
    }

    hide() {
        this.$el.hide(); return this;
    }

    remove() {
        this.$el.remove(); return this;
    }
}

module.exports = Core;